import React from 'react'
import { Button, Icon, Radio, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import SearchInput from './SearchInput'
import AdsToolbarHolder from '../styles/adsToolbarStyle'

const { Option } = Select

const AdsToolbar = ({
  onSearch,
  viewMode,
  onViewModeChange,
  sort,
  onSortChange,
  filtersOpen,
  onToggleFilters,
}) => {
  const { t } = useTranslation()

  return (
    <AdsToolbarHolder>
      <div className="left">
        <Button
          className={filtersOpen ? 'filters-button active' : 'filters-button'}
          onClick={onToggleFilters}
        >
          {t('Filters')} <Icon type="filter" />
        </Button>
        <SearchInput placeholder={t('Search ads')} onSearch={onSearch} />
      </div>

      <div className="right">
        <Radio.Group
          value={viewMode}
          onChange={(e) => onViewModeChange(e.target.value)}
          buttonStyle="solid"
        >
          <Radio.Button value="grid">
            <Icon type="appstore" />
          </Radio.Button>
          <Radio.Button value="list">
            <Icon type="unordered-list" />
          </Radio.Button>
        </Radio.Group>

        <Select
          value={sort || undefined}
          onChange={onSortChange}
          placeholder={t('Sort')}
          allowClear
          style={{ minWidth: 150 }}
        >
          <Option value="newest">{t('Most recent')}</Option>
          <Option value="oldest">{t('Oldest')}</Option>
          <Option value="name">{t('Name')}</Option>
        </Select>
      </div>
    </AdsToolbarHolder>
  )
}

export default AdsToolbar
